import "../styles/Content.css";
import React from "react";

const Content = ({ children }) => {
  return <div className="content-box">{children}</div>;
};

export default Content;
